<template>
  <div class="tl">
    <Breadcrumbs main="Рейтинг" title="Сезонный рейтинг BPL"/>

    <div class="container-fluid tl-container">

      <div class="tl-toolbar">
        <div class="tl-toolbar__main">
          <label class="rt-season">
            <span class="rt-season__label">Сезон</span>
            <b-select class="rt-season__select"
                      v-model="selectedBplSeason"
                      :options="selectOptions"
                      @change="handleSeasonChange"/>
          </label>

          <div class="tl-spacer"></div>

          <router-link :to="{ name: 'rating_bpl' }" class="tl-btn-ghost">
            <i class="fa fa-plus"></i> Новый сезон
          </router-link>

          <button type="button" class="tl-btn-primary"
                  :disabled="isLoadingActualization"
                  @click="getActualizedBpl">
            <i class="fa" :class="isLoadingActualization ? 'fa-spinner rt-spin' : 'fa-refresh'"></i>
            {{ isLoadingActualization ? 'Идёт актуализация…' : 'Актуализировать' }}
          </button>
        </div>

        <div class="rt-meta">
          <span v-if="currentSeasonName">Сезон: <b>{{ currentSeasonName }}</b></span>
          <span v-if="total">Игроков в рейтинге: <b>{{ total }}</b></span>
        </div>
      </div>

      <div class="tl-panel">
        <div v-if="isLoadingRatingForBplUsers" class="tl-skeleton">
          <div v-for="n in 8" :key="'sk' + n" class="tl-skeleton__row">
            <span class="tl-sk tl-sk--sm"></span>
            <span class="tl-sk tl-sk--wide"></span>
            <span class="tl-sk"></span>
            <span class="tl-sk tl-sk--sm"></span>
          </div>
        </div>

        <div v-else-if="!usersRating.length" class="tl-empty">
          <div class="tl-empty__art"><i class="fa fa-trophy"></i></div>
          <div class="tl-empty__title">Нет данных по сезону</div>
          <div class="tl-empty__text">Выберите другой сезон или актуализируйте рейтинг.</div>
        </div>

        <div v-else class="tl-table-wrap">
          <b-table class="tl-table rt-table"
                   responsive
                   hover
                   borderless
                   :items="usersRating"
                   :fields="fields"
                   @row-clicked="openHistory">
            <template #cell(place)="{ item }">
              <span class="rt-place" :class="placeClass(item.place)">{{ item.place }}</span>
            </template>

            <template #cell(username)="{ item }">
              <div class="rt-team">
                <div>
                  <router-link class="rt-team__name"
                               :to="{ name: 'bpl_season_user_rating_history', params: { id: item.id }, query: { season: selectedBplSeason } }"
                               @click.native.stop>{{ item.username || 'без ника' }}</router-link>
                  <span class="rt-team__sub">ID {{ item.id }}</span>
                </div>
              </div>
            </template>

            <template #cell(nickname)="{ item }">
              <span v-if="item.nickname">{{ item.nickname }}</span>
              <span v-else class="rt-dim">не указан</span>
            </template>

            <template #cell(rating)="{ item }">
              <span class="rt-rating">{{ item.rating }}</span>
            </template>

            <template #cell(kill_sum)="{ item }">
              <span class="rt-count">{{ item.kill_sum }}</span>
            </template>

            <template #cell(action)="{ item }">
              <router-link class="tl-icon-btn rt-open"
                           :to="{ name: 'bpl_season_user_rating_history', params: { id: item.id }, query: { season: selectedBplSeason } }"
                           @click.native.stop
                           v-b-tooltip.hover.left="'История начислений'">
                <i class="fa fa-angle-right"></i>
              </router-link>
            </template>
          </b-table>
        </div>

        <div v-if="!isLoadingRatingForBplUsers && usersRating.length" class="tl-foot">
          <div class="tl-foot__info">
            Показано <b>{{ usersRating.length }}</b> из <b>{{ total }}</b>
          </div>
          <b-pagination class="tl-pagination my-0"
                        v-model="currentPage"
                        :total-rows="total"
                        :per-page="perPage"
                        :limit="7"
                        :disabled="isLoadingRatingForBplUsers"
                        @change="handlePageChange"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "BplSeasonalRating",
  data() {
    const {season, page} = this.$route.query;

    return {
      selectOptions: [],
      selectedBplSeason: season ? Number(season) : null,
      isLoadingActualization: false,
      isLoadingRatingForBplUsers: false,
      currentPage: Number(page) || 1,
      perPage: 30,
      total: 0,
      usersRating: [],
      fields: [
        {key: 'place', label: '#', sortable: true, thClass: 'rt-th--place'},
        {key: 'username', label: 'Игрок', sortable: true},
        {key: 'nickname', label: 'Ник в игре', sortable: true},
        {key: 'rating', label: 'Рейтинг', sortable: true, thClass: 'rt-th--num'},
        {key: 'kill_sum', label: 'Киллы', sortable: true, thClass: 'rt-th--num'},
        {key: 'action', label: '', sortable: false, thClass: 'tl-th--act', tdClass: 'tl-td--act'},
      ],
    }
  },
  computed: {
    currentSeasonName() {
      const season = (this.selectOptions || []).find((option) => option.value === this.selectedBplSeason);
      return season ? season.text : '';
    },
  },
  methods: {
    placeClass(place) {
      if (Number(place) === 1) return 'rt-place--gold';
      if (Number(place) === 2) return 'rt-place--silver';
      if (Number(place) === 3) return 'rt-place--bronze';
      return '';
    },

    openHistory(item) {
      this.$router.push({
        name: 'bpl_season_user_rating_history',
        params: {id: item.id},
        query: {season: this.selectedBplSeason},
      });
    },

    async getActualizedBpl() {
      try {
        this.isLoadingActualization = true;
        await api.rating.actualizedUsersBplSeasonal();

        // После актуализации перезагружаем текущие данные
        await this.getUsersBplSeasonalRating(this.currentPage);
      } catch (e) {
        console.error('Error actualizing BPL:', e);
      } finally {
        this.isLoadingActualization = false;
      }
    },

    async getUsersBplSeasonalRating(page = 1) {
      if (!this.selectedBplSeason) {
        console.warn('No season selected');
        return;
      }

      try {
        this.isLoadingRatingForBplUsers = true;

        const params = { page: page };

        const response = await api.rating.getUsersBplWithSeasonId(
            this.selectedBplSeason,
            params
        );

        const apiData = response.data || response;

        if (apiData && apiData.message === "Success!" && Array.isArray(apiData.data)) {
          this.$set(this, 'usersRating', [...apiData.data]);
          this.total = apiData.pagination ? apiData.pagination.total : this.usersRating.length;
          this.perPage = apiData.pagination ? apiData.pagination.by : 30;
          this.currentPage = apiData.pagination ? apiData.pagination.page : page;
          this.syncQuery();
        } else {
          console.error('Unexpected API response format:', apiData);
          this.usersRating = [];
          this.total = 0;
        }

      } catch (e) {
        console.error('Error loading rating data:', e);
        this.usersRating = [];
        this.total = 0;
      } finally {
        this.isLoadingRatingForBplUsers = false;
      }
    },

    async getBplSeasons() {
      try {
        console.log('Loading BPL seasons...');
        const res = await api.tournament.getBplSeasons();
        console.log('BPL Seasons response:', res);

        const data = res.data || res;
        this.selectOptions = data.data.map(item => ({
          value: item.id,
          text: item.name
        }));

        if (this.selectOptions.length > 0) {
          const isSeasonFromQueryValid = this.selectOptions
              .some(option => option.value === this.selectedBplSeason);

          if (!isSeasonFromQueryValid) {
            this.selectedBplSeason = this.selectOptions[0].value;
            this.currentPage = 1;
          }

          this.syncQuery();
          this.getUsersBplSeasonalRating(this.currentPage);
        }
      } catch (e) {
        console.error('Error loading BPL seasons:', e);
      }
    },

    handlePageChange(pageNumber) {
      console.log('Page changed to:', pageNumber, 'from:', this.currentPage);
      this.currentPage = pageNumber;
      this.syncQuery();
      this.getUsersBplSeasonalRating(pageNumber);
    },

    handleSeasonChange(seasonId) {
      console.log('Season changed to:', seasonId);
      this.selectedBplSeason = seasonId;
      this.currentPage = 1; // Сброс на первую страницу при смене сезона
      this.syncQuery();
      this.getUsersBplSeasonalRating(1);
    },

    // Держим выбранный сезон и страницу в query, чтобы состояние
    // восстанавливалось при возврате из деталей пользователя
    syncQuery() {
      const season = this.selectedBplSeason ? String(this.selectedBplSeason) : undefined;
      const page = String(this.currentPage);

      if (this.$route.query.season === season && this.$route.query.page === page) return;

      this.$router
          .replace({query: {...this.$route.query, season, page}})
          .catch(() => {});
    }
  },

  mounted() {
    console.log('Component mounted');
    this.getBplSeasons();
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/admin-list.scss";
@import "~@/assets/scss/rating-list.scss";

.tl {
  @include rating-list-parts;

  /* выбор сезона: подпись рядом с полем, а не над таблицей отдельной строкой */
  .rt-season {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    margin: 0;

    &__label {
      font-size: 11px;
      font-weight: 700;
      letter-spacing: .06em;
      text-transform: uppercase;
      color: var(--tl-muted);
    }

    &__select {
      width: auto;
      min-width: 180px;
      height: 40px;
      border: 1px solid var(--tl-border);
      border-radius: 10px;
      background-color: var(--tl-bg);
      color: var(--tl-text);
      font-size: 13px;

      &:focus {
        border-color: var(--tl-primary);
        box-shadow: 0 0 0 3px var(--tl-primary-soft);
      }
    }
  }
}
</style>
